const CATEGORIES = {};
CATEGORIES.V2 = {};

CATEGORIES.V2.PLAYERS = 'PLAYERS';
CATEGORIES.V2.PLAYERS_STATS = 'PLAYERS_STATS';
CATEGORIES.V2.PLAYERS_H2H = 'PLAYERS_H2H';

CATEGORIES.V2.TEAMS_FIXTURES = 'TEAMS_FIXTURES';

CATEGORIES.V2.TEAMS = 'TEAMS';
CATEGORIES.V2.TEAMS_H2H = 'TEAMS_H2H';

CATEGORIES.V2.MATCH = 'MATCH';
CATEGORIES.V2.MATCH_PRE = 'MATCH_PRE';
CATEGORIES.V2.MATCH_LIVE = 'MATCH_LIVE';

CATEGORIES.V2.MATCH_POST = 'MATCH_POST';
CATEGORIES.V2.MATCH_DETAILED_PRE = 'MATCH_DETAILED_PRE';
CATEGORIES.V2.MATCH_DETAILED_LIVE = 'MATCH_DETAILED_LIVE';
CATEGORIES.V2.MATCH_DETAILED_POST = 'MATCH_DETAILED_POST';
CATEGORIES.V2.MATCH_DETAILED_STREAKS = 'MATCH_DETAILED_STREAKS';
CATEGORIES.V2.MATCH_DETAILED_LINEUP = 'MATCH_DETAILED_LINEUP';
CATEGORIES.V2.MATCH_DETAILED_STATS = 'MATCH_DETAILED_STATS';

CATEGORIES.V2.STREAKS = 'STREAKS';
CATEGORIES.V2.BOOKIES = 'BOOKIES';
CATEGORIES.V2.TOP_LISTS = 'TOP_LIST';
CATEGORIES.V2.EDITORIAL = 'EDITORIAL';
CATEGORIES.V2.TRANSFERS = 'TRANSFERS';

CATEGORIES.V2.ODDS = 'ODDS';

CATEGORIES.V2.BASEBALL = 'BASEBALL';

CATEGORIES.V2.TOURNAMENT_FIXTURES = 'TOURNAMENT_FIXTURES';
CATEGORIES.V2.TOURNAMENT_TABLES = 'TOURNAMENT_TABLES';
CATEGORIES.V2.TOURNAMENT = 'TOURNAMENT';

export default CATEGORIES;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/widgetCategories.js
 **/